import { formatYmdHms } from '@/utils/datetime'

/** rewards API status — 적립·사용취소 +, 사용·적립취소·만료 - */
export type RewardHistoryStatus =
  | 'EARN'
  | 'EARN_CANCEL'
  | 'USE'
  | 'USE_CANCEL'
  | 'EXPIRE'

export type RewardAmountStyle = 'positive' | 'negative' | 'cancelled'

export const REWARD_TYPE_LABEL: Record<'STAMP' | 'POINT', string> = {
  STAMP: '스탬프',
  POINT: '포인트'
}

export const REWARD_STATUS_LABEL: Record<RewardHistoryStatus, string> = {
  EARN: '적립',
  EARN_CANCEL: '적립취소',
  USE: '사용',
  USE_CANCEL: '사용취소',
  EXPIRE: '만료'
}

export function rewardTypeLabel(rewardType: string): string {
  return REWARD_TYPE_LABEL[rewardType as 'STAMP' | 'POINT'] ?? rewardType
}

export function rewardStatusLabel(status: string): string {
  return REWARD_STATUS_LABEL[status as RewardHistoryStatus] ?? status
}

/** status 기준 부호 정규화 (API가 절댓값만 내려줘도 동일하게 표시) */
export function signedRewardQuantity(quantity: number, status: string): number {
  const abs = Math.abs(quantity)
  if (status === 'EARN' || status === 'USE_CANCEL') return abs
  if (status === 'USE' || status === 'EARN_CANCEL' || status === 'EXPIRE') return -abs
  return quantity
}

/** processAt(ISO 8601) → YYYY.MM.DD HH:mm:ss (project timezone, 없으면 로컬) */
export function formatProcessAt(isoString: string): string {
  return formatYmdHms(isoString)
}

export function formatRewardAmountDisplay(
  quantity: number,
  rewardType: 'STAMP' | 'POINT',
  status: string
): string {
  const signed = signedRewardQuantity(quantity, status)
  if (rewardType === 'STAMP') {
    return `${signed} 스탬프`
  }
  return `${signed.toLocaleString()}P`
}

export function getRewardAmountStyle(status: string): RewardAmountStyle {
  if (status === 'EARN_CANCEL' || status === 'USE_CANCEL') return 'cancelled'
  if (status === 'EARN') return 'positive'
  return 'negative'
}
